import { FC, useMemo } from "react";

import { SessionStatsCard } from "./SessionStatsCard";

import type { ClassSessionType } from "components/server-types";
import { t } from "i18n/i18n";
import { FlagIcon, HandRaiseOutlineIcon } from "mds/icons";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentCourseId, selectStudentClassSessionUserSummaries } from "store/selectors";
import { computeAttendanceStats } from "utils/metrics-utils";

type AttendanceCardProps = {
  sessions: ClassSessionType[];
};

export const AttendanceCard: FC<AttendanceCardProps> = ({ sessions }) => {
  const courseId = useAppSelector(selectCurrentCourseId);
  const studentSummaries = useAppSelector(selectStudentClassSessionUserSummaries);
  const { canAuthorCourse } = useCapabilities();

  const { averageAttendance, highestAttendance } = useMemo(
    () => computeAttendanceStats(sessions, studentSummaries),
    [sessions, studentSummaries],
  );

  if (!canAuthorCourse || !courseId) return null;

  const isEmpty = sessions.length === 0;
  const highestText = highestAttendance.date
    ? t("session_log_view.stats.attendance.highest", highestAttendance)
    : t("session_log_view.stats.attendance.no_sessions");

  return (
    <SessionStatsCard
      FooterIcon={FlagIcon}
      footerText={highestText}
      isEmpty={isEmpty}
      kind="attendance"
      title={t("session_log_view.stats.attendance.title")}
      TitleIcon={HandRaiseOutlineIcon}
      value={isEmpty ? 0 : `${averageAttendance}%`}
      valueDescription={t("session_log_view.stats.attendance.value_description")}
    />
  );
};
